import { useParams } from 'js/lib/useRouter';

import { redirectClientOrServer } from 'bundles/common/utils/urlUtils';

/**
 * Redirect /organizations/:orgSlug/view-all-collections/browse → org home.
 * The "browse" collection type maps to the org home page in org-scoped.
 */
export const ViewAllBrowseRedirect = () => {
  const { orgSlug } = useParams();
  if (!orgSlug) return null;
  redirectClientOrServer(`/organizations/${orgSlug}`);
  return null;
};

/**
 * Redirect legacy collection routes to the consolidated view-all curated tab.
 * Handles both:
 *   /organizations/:orgSlug/collections/:collectionId
 *   /organizations/:orgSlug/collections/:contextType/:contextId
 */
export const CollectionLegacyRedirect = () => {
  const { orgSlug } = useParams();
  if (!orgSlug) return null;
  redirectClientOrServer(`/organizations/${orgSlug}/view-all-collections/curated`);
  return null;
};
